export const assessmentFormExamples = [
  // {
  //   contributorId: 5,
  //   language: "English",
  //   title: "Vocabulary quiz using suffixes",
  //   template_type: "assessment",
  //   includeUserGroups: [
  //     "cy-rav",
  //     "cy-sj",
  //     "cy-testing"
  //   ],
  //   excludeUserGroups: [],
  //   formData: {
  //     subject: "English",
  //     grade: "Grade 5",
  //     show_text: "Closed book",
  //     length: null,
  //     questions: {
  //       skills: {
  //         analysis: true,
  //         knowledge: true,
  //         application: true,
  //         comprehension: true
  //       },
  //       mc_options: 4,
  //       fb_quantity: 0,
  //       ff_quantity: 0,
  //       mc_quantity: 5,
  //       tf_quantity: 0
  //     },
  //     difficulty_level: "Hard",
  //     genre: "List of terms (eg: lesson plan, terms, syllabus, notes, etc)",
  //     text: "vocabulary using suffixes: -ion, -ation, -ition, -tion, -er/-or, -ent, -ist, -ment",
  //     assessment_instructions: "",
  //     text_instructions: null
  //   },
  //   includeImages: false,
  //   includeParagraphNumbers: false,
  //   primary_source: false
  // },
  {
    language: "English",
    template_type: "assessment",
    includeUserGroups: ["bt-testing", "bt-ctx"],
    // Exclude takes precedence over include
    excludeUserGroups: [],
    title: "Create a Kahoot (Multiple-choice) based on a lesson plan",
    formData: {
      subject: "Science",
      grade: "Grade 6",
      show_text: "Closed book",
      questions: {
        mc_quantity: 10,
        ff_quantity: 0,
        tf_quantity: 0,
        fb_quantity: 0,
        mc_options: 4,
        skills: {
          knowledge: true,
          analysis: true,
          comprehension: true,
          application: true,
        },
      },
      difficulty_level: "Medium",
      genre: "List of terms (eg: lesson plan, terms, syllabus, notes, etc)",
      text: `Unit on [insert topic]

Summary: [copy summary from lesson plan]

Learning Objectives: [copy objectives from lesson plan]

Key Vocabulary: [copy key vocabulary from lesson plan]

Personalize each question to one of the following:
[add your personalization. eg Setting: Del Valle Middle School
Students: Lisa - favorite food burger, Evan - favorite food sour patches, Maria - favorite food chicken nuggets]`,
      assessment_instructions: "",
    },
  },
  {
    language: "English",
    template_type: "assessment",
    includeUserGroups: ["bt-testing", "bt-ctx"],
    // Exclude takes precedence over include
    excludeUserGroups: [],
    title: "Create a Kahoot (True/False) based on a lesson plan",
    formData: {
      subject: "Science",
      grade: "Grade 6",
      show_text: "Closed book",
      questions: {
        mc_quantity: 0,
        ff_quantity: 0,
        tf_quantity: 10,
        fb_quantity: 0,
        mc_options: 4,
        skills: {
          knowledge: true,
          analysis: true,
          comprehension: true,
          application: true,
        },
      },
      difficulty_level: "Medium",
      genre: "List of terms (eg: lesson plan, terms, syllabus, notes, etc)",
      text: `Unit on [insert topic]

Summary: [copy summary from lesson plan]

Learning Objectives: [copy objectives from lesson plan]

Key Vocabulary: [copy key vocabulary from lesson plan]

Personalize each question to one of the following:
[add your personalization. eg Setting: Del Valle Middle School
Students: Lisa - favorite food burger, Evan - favorite food sour patches, Maria - favorite food chicken nuggets]`,
      assessment_instructions: "",
    },
  },
  {
    language: "English",
    title: `Create a science quiz based on a vocab list (fill-in-the-blanks)`,
    template_type: "assessment",
    includeUserGroups: ["bt-testing", "bt-ctx"],
    // Exclude takes precedence over include
    excludeUserGroups: [],

    formData: {
      subject: "Science",
      grade: "Grade 6",
      show_text: "Closed book",
      questions: {
        mc_quantity: 0,
        ff_quantity: 0,
        tf_quantity: 0,
        fb_quantity: 10,
        mc_options: 4,
        skills: {
          knowledge: true,
          analysis: true,
          comprehension: true,
          application: true,
        },
      },
      difficulty_level: "Medium",
      genre: "List of terms (eg: lesson plan, terms, syllabus, notes, etc)",
      text: `Unit on [insert topic]

Summary: [copy summary from lesson plan]

Learning Objectives: [copy objectives from lesson plan]

Key Vocabulary: [copy key vocabulary from lesson plan]

Personalize each question to one of the following:
[add your personalization. eg Setting: Del Valle Middle School
Students: Lisa - favorite food burger, Evan - favorite food sour patches, Maria - favorite food chicken nuggets]`,
      assessment_instructions: "Make a vocab quiz where students need to fill in one of the words from the list. Only use words from the given vocab list."
    },
  },
  {
    language: "English",
    template_type: "assessment",
    includeUserGroups: ["bt-testing", "bt-ctx"],
    // Exclude takes precedence over include
    excludeUserGroups: [],
    title: "Create a formative assessment based on a lesson plan",
    formData: {
      subject: "Science",
      grade: "Grade 6",
      show_text: "Closed book",
      questions: {
        mc_quantity: 5,
        ff_quantity: 3,
        tf_quantity: 5,
        fb_quantity: 0,
        mc_options: 4,
        skills: {
          knowledge: true,
          analysis: true,
          comprehension: true,
          application: true,
        },
      },
      difficulty_level: "Medium",
      genre: "List of terms (eg: lesson plan, terms, syllabus, notes, etc)",
      text: `Unit on [insert topic]

Summary: [copy summary from lesson plan]

Learning Objectives: [copy objectives from lesson plan]

Key Vocabulary: [copy key vocabulary from lesson plan]

Personalize each question to one of the following:
[add your personalization. eg Setting: Del Valle Middle School
Students: Lisa - favorite food burger, Evan - favorite food sour patches, Maria - favorite food chicken nuggets]`,
      assessment_instructions: "",
    },
  },
  {
    language: "English",
    title: `Practice Comprehension using a specific text`,
    template_type: "assessment",
    includeUserGroups: ["all"],
    // Exclude takes precedence over include
    excludeUserGroups: ["bt-testing", "bt-ctx"],

    formData: {
      subject: "Science",
      grade: "Grade 6",
      show_text: "Open book",
      questions: {
        mc_quantity: 10,
        ff_quantity: 2,
        tf_quantity: 0,
        fb_quantity: 0,
        mc_options: 4,
        skills: {
          theme: true,
          analysis: true,
          vocabulary: true,
          structure: false,
          tone: false,
        },
      },
      difficulty_level: "Medium",
      genre: "Nonfiction text (eg: textbook chapter, primary source, etc)",
      text: "<Include or upload your text here>",
      assessment_instructions: ``
    },
  },
  {
    language: "English",
    title: `Fill-in-the-blanks for vocab skill building`,
    template_type: "assessment",
    includeUserGroups: ["cy-rav", "cy-sj", "cy-testing"],
    // Exclude takes precedence over include
    excludeUserGroups: [],

    formData: {
      subject: "English",
      grade: "Grade 2",
      show_text: "Closed book",
      questions: {
        mc_quantity: 0,
        ff_quantity: 0,
        tf_quantity: 0,
        fb_quantity: 8,
        mc_options: 4,
        skills: {
          knowledge: true,
          analysis: true,
          comprehension: true,
          application: true,
        },
      },
      difficulty_level: "Easy",
      genre: "List of terms (eg: lesson plan, terms, syllabus, notes, etc)",
      text: `grass, stick, chalk, rock, ball, fish, tree, boat`,
      assessment_instructions: "Make a vocab quiz where students fill in one of the words from the list. Only use words from the given vocab list. Keep the sentences simple and clear."
    },
  },
  {
    language: "English",
    title: `Vocab quizzes for language learners`,
    template_type: "assessment",
    includeUserGroups: ["cy-rav", "cy-sj", "cy-testing"],
    // Exclude takes precedence over include
    excludeUserGroups: [],

    formData: {
      subject: "English",
      grade: "Grade 4",
      show_text: "Closed book",
      questions: {
        mc_quantity: 8,
        ff_quantity: 0,
        tf_quantity: 0,
        fb_quantity: 8,
        mc_options: 4,
        skills: {
          knowledge: true,
          analysis: false,
          comprehension: true,
          application: false,
        },
      },
      difficulty_level: "Easy",
      genre: "List of terms (eg: lesson plan, terms, syllabus, notes, etc)",
      text: `adventure, brace, clever, discover, enormous, fragile, giggle, harvest, invisible, journey, kindness`,
      assessment_instructions: "Create an assessment to evaluate students’ knowledge and understanding of these vocabulary words."
    },
  },
  {
    language: "English",
    title: `Grammar practice - Capitalization`,
    template_type: "assessment",
    includeUserGroups: ["cy-rav", "cy-sj", "cy-testing"],
    // Exclude takes precedence over include
    excludeUserGroups: [],

    formData: {
      subject: "English",
      grade: "Grade 2",
      show_text: "Closed book",
      questions: {
        mc_quantity: 0,
        ff_quantity: 0,
        tf_quantity: 8,
        fb_quantity: 0,
        mc_options: 4,
        skills: {
          knowledge: true,
          analysis: false,
          comprehension: false,
          application: false,
        },
      },
      difficulty_level: "Easy",
      genre: "List of terms (eg: lesson plan, terms, syllabus, notes, etc)",
      text: `Grammar rules - Capitalization: 
      Capitalize the first word of a sentence. 
      Capitalize proper nouns (names of people, places, days of the week, months).
      `,
      assessment_instructions: `Create a set of sentences to see if students can recognize correct capitalization.
      Example:
      the cat sat on the mat. (Answer: FALSE)
      I play soccer on Monday. (Answer: TRUE)  
      `
    },
  },
  {
    language: "English",
    title: `Grammar practice - Punctuation`,
    template_type: "assessment",
    includeUserGroups: ["cy-rav", "cy-sj", "cy-testing"],
    // Exclude takes precedence over include
    excludeUserGroups: [],

    formData: {
      subject: "English",
      grade: "Grade 2",
      show_text: "Closed book",
      questions: {
        mc_quantity: 0,
        ff_quantity: 0,
        tf_quantity: 0,
        fb_quantity: 8,
        mc_options: 4,
        skills: {
          knowledge: false,
          analysis: false,
          comprehension: false,
          application: true,
        },
      },
      difficulty_level: "Easy",
      genre: "List of terms (eg: lesson plan, terms, syllabus, notes, etc)",
      text: `Grammar rules - Punctuation: 
      Use periods at the end of statements.
      Use question marks at the end of questions.
      Use exclamation points for sentences expressing strong emotion.
      `,
      assessment_instructions: `Create a set of sentences to see if students can apply the punctuation rules.
      Examples:
      Can you come to my house _________ (Answer: ?)
      I like red candy __________ (Answer: .)  
      `
    },
  },
  {
    language: "English",
    title: `Grammar practice - Subject-Verb agreement`,
    template_type: "assessment",
    includeUserGroups: ["cy-rav", "cy-sj", "cy-testing"],
    // Exclude takes precedence over include
    excludeUserGroups: [],

    formData: {
      subject: "English",
      grade: "Grade 2",
      show_text: "Closed book",
      questions: {
        mc_quantity: 0,
        ff_quantity: 0,
        tf_quantity: 8,
        fb_quantity: 0,
        mc_options: 4,
        skills: {
          knowledge: false,
          analysis: false,
          comprehension: false,
          application: true,
        },
      },
      difficulty_level: "Easy",
      genre: "List of terms (eg: lesson plan, terms, syllabus, notes, etc)",
      text: `Grammar rules - Subject-Verb agreement: 
      Ensure that the subject and verb in a sentence agree in number (e.g., "She runs," "They run").
      `,
      assessment_instructions: `Create a set of sentences to see if students can recognize correct use of the subject-verb agreement rule.
      Examples:
      The ice cream truck plays a silly tune as it drives down our street. (Answer: TRUE)
      She splash in the puddles with her shiny, new rain boots.. (Answer: FALSE)  

      make the sentences relatable and fun (not boring!) for 2nd grade students.
      `
    },
  },
  {
    language: "English",
    title: `Comprehension of a passage, excerpt, poem, or text`,
    template_type: "assessment",
    includeUserGroups: ["all"],
    // Exclude takes precedence over include
    excludeUserGroups: ["bt-testing", "bt-ctx"],

    formData: {
      subject: "History",
      grade: "Grade 6",
      show_text: "Closed book",
      questions: {
        mc_quantity: 5,
        ff_quantity: 2,
        tf_quantity: 0,
        fb_quantity: 0,
        mc_options: 4,
        skills: {
          knowledge: true,
          analysis: true,
          comprehension: true,
          application: true,
        },
      },
      difficulty_level: "Medium",
      genre: "Nonfiction text (eg: textbook chapter, primary source, etc)",
      text: `Source: Excerpts from the Epilogue of Hammurabi’s Code, circa 1754 BCE.

      ...Hammurabi, the protecting king am I... That the strong might not injure the weak, in order to protect the widows and orphans...I set up these my precious words, written upon my memorial stone, before the image of me, as king of righteousness.
      ...By the command of Shamash, the great god and judge of heaven and earth...let righteousness go forth in the land... Let no destruction befall my monument... let my name be ever repeated; let the oppressed, who has a case at law, come and stand before this my image as king of righteousness; let him read the inscription, and understand my precious words.
      ...In future times...through all coming generations, let the king, who may be in the land, observe the words of righteousness which I have written on my monument; let him not alter the law of the land which I have given...
      ...If this ruler does not esteem my words... if he destroys the law which I have given,...may the great gods of heaven and earth...inflict a curse upon his family, his land, his warriors, his subjects, and his troops.

      `,
      assessment_instructions: ``
    },
  },
  {
    language: "English",
    template_type: "assessment",
    includeUserGroups: ["all"],
    // Exclude takes precedence over include
    excludeUserGroups: ["bt-testing", "bt-ctx"],
    title: "An assessment based on a lesson plan",
    formData: {
      subject: "History",
      grade: "Grade 10",
      show_text: "Closed book",
      questions: {
        mc_quantity: 5,
        ff_quantity: 3,
        tf_quantity: 5,
        fb_quantity: 5,
        mc_options: 4,
        skills: {
          knowledge: true,
          analysis: true,
          comprehension: true,
          application: true,
        },
      },
      difficulty_level: "Medium",
      genre: "List of terms (eg: lesson plan, terms, syllabus, notes, etc)",
      text: `Topics: Populism era, exploring its roots in the marginalized western farmers, its challenge to the established two-party system, and the parallels between key societal issues of the Progressive Era and today's concerns.

Text book: Give me Liberty by Eric Foner

Key terms: Progressive Era. Populism. Homestead Act. Corporate abuses. Monopolies. Wealth gap. Women’s rights. Race discussions. Immigration. Granger Movement. People’s Party. William Jennings Bryan. Omaha Platform. Third-party system. Winner-takes-all voting. Duverger’s Law.

A few extra notes:
  - Parallels with today's societal issues: Environmental concerns: then (conservationism) vs. now (climate change). Abuses by large corporations and company monopolies. Wealth gap disparities. Women’s rights: then (voting) vs. now (ERA, abortion). Racial debates: then (inherent inequality) vs. now (defining equality). Immigration debates.
  - Populism’s Inception: Initiated by marginalized western farmers. Self-organizing farmers led to the Populist Party.
      Challenged the dominant two-party system.
  - Populists aligned with southern farmers, black farmers (at least at first), Northern industrial workers, and women. To gain Southern white votes, they severed ties with black Populists.
  - Election: William Jennings Bryan as their representative. Lost due to limited funds and separation from black Populists.
  - Legacy: Persistence of many Populist ideas. Major parties fortified defenses against third parties. Highlighted detrimental impacts of racism.`,
      assessment_instructions: "",
    },
  },
  {
    language: "Spanish",
    title: "A Spanish vocab quiz for language learners",
    template_type: "assessment",
    includeUserGroups: ["all"],
    // Exclude takes precedence over include
    excludeUserGroups: ["cy-rav", "cy-sj", "cy-testing", "bt-testing", "bt-ctx"],
    formData: {
      subject: "World languages",
      grade: "Grade 7",
      show_text: "Closed book",
      questions: {
        mc_quantity: 5,
        ff_quantity: 3,
        tf_quantity: 5,
        fb_quantity: 5,
        mc_options: 4,
        skills: {
          knowledge: true,
          analysis: true,
          comprehension: true,
          application: true,
        },
      },
      difficulty_level: "Medium",
      genre: "List of terms (eg: lesson plan, terms, syllabus, notes, etc)",
      text: `el plato
la fruta
la verdura
el postre
cortar
mezclar 
asar
la especia
el sabor        
cocinar
la receta
el ingrediente
hornear
freír
la cena
el almuerzo
el desayuno
el restaurante
el menú
pedir
degustar
la servilleta
el camarero/la camarera
la cuenta 
ver
poder
allí 
aquí
tal vez
¿Dónde?
¿Cuándo?
cuándo
picar`,
      assessment_instructions:
        "Create an assessment to evaluate students’ knowledge and understanding of these vocabulary words",
    },
  },
  {
    language: "English",
    title: `Literature comprehension - A passage from The Odyssey`,
    template_type: "assessment",
    includeUserGroups: ["all"],
    // Exclude takes precedence over include
    excludeUserGroups: ["cy-rav", "cy-sj", "cy-testing", "bt-testing", "bt-ctx"],
    formData: {
      subject: "English",
      grade: "Grade 9",
      show_text: "Open book",
      questions: {
        mc_quantity: 5,
        ff_quantity: 3,
        tf_quantity: 5,
        fb_quantity: 0,
        mc_options: 4,
        skills: {
          theme: true,
          analysis: true,
          vocabulary: true,
          structure: true,
          tone: true,
        },
      },
      difficulty_level: "Medium",
      genre: "Fictional text (eg: reading passage, book chapter, poem, etc)",
      text: `    The killer of Argus, the gods’ great messenger,
    said these words and left. The regal nymph Calypso,
    once she heard Zeus’s message, went away to find
    great-hearted Odysseus. She met him on the shore,
    sitting by the sea, his eyes always full of tears,
190
    because he was squandering his sweet life, mourning
    for his return. The nymph no longer gave him joy.
    At night he slept beside her in the hollow cave,
    as he was forced to do—not of his own free will,
    though she was keen enough. But in the daylight hours
    he’d sit down on the rocks along the beach, his heart
    straining with tears and groans and sorrow, as he gazed,
    through his tears, over the restless sea. Moving up,
    close to him, the lovely goddess spoke:
    “Poor man, spend no more time grieving on this island,
200
    wasting your life away. My heart agrees—
    the time has come for me to send you off.
    So come now, cut long timbers with an axe,
    and make a raft, a large one. Build a deck
    high up on it, so it can carry you
    across the misty sea. I’ll provision it
    with all the food and water and red wine
    you’re going to need to satisfy your wants.
    I’ll give you clothes and send a favouring wind
    blowing from your stern, so you may reach
210
    your own native land unharmed, if the gods
    are willing, the ones who hold wide heaven,
    whose will and force are mightier than mine.”
    Calypso finished her speech. Odysseus trembled,
    then replied to her—his words had wings:

    “Goddess, in all this you’re planning something different.
    You don’t want me to get home, when you tell me
    to go across that huge gulf of the sea
    and in a raft—a harsh and dangerous trip.
    Not even swift well-balanced ships get through
220
    when they enjoy fair winds from Zeus. Besides,
    without your consent I’d never board a raft,
    not unless you, goddess, would undertake
    to swear a mighty oath on my behalf
    you’ll not come up with other devious plans
    to injure me.”

    Odysseus finished speaking.
    Calypso, the lovely goddess, smiled, caressed him,
    and then replied by saying:

    “You’re a cunning man,
    with no lack of wit—to even consider
    answering me like that. But let the earth
230
    stand as witness, and wide heaven above,
    and flowing waters of the river Styx—
    the mightiest and most terrible oath
    the blessed gods can make—I will not plan
    any other injury against you. No.
    I’ll think of things and give advice, as if
    I was scheming for my own advantage,
    if ever I should be in such distress.
    For my mind is just, and inside my chest
    there is no iron heart—it feels pity,
240
    just like your own.”

    The beautiful goddess
    finished speaking, then quickly led him from the place.
    Odysseus followed in her footsteps. Man and goddess
    entered the hollow cave. He sat down in the chair
    Hermes had just risen from, and the nymph set out
    all kinds of food to eat and drink, the sort of things
    mortal human beings consume. She took a seat
    opposite god-like Odysseus, and her servants
    placed ambrosia and nectar right beside her.
    The two of them reached out to take the tasty food
250
    spread out in front of them. When they had had their fill
    of food and drink, beautiful divine Calypso
    was the first to speak:
    “Nobly born son of Laertes,
    resourceful Odysseus, so you now wish
    to get back to your own dear native land
    without delay? In spite of everything,
    I wish you well. If your heart recognized
    how much distress Fate has in store for you
    before you reach your homeland, you’d stay here
    and keep this home with me. You’d never die,
260
    not even if you yearned to see your wife,
    the one you always long for every day.
    I can boast that I’m no worse than her
    in how I look or bear myself—it’s wrong
    for mortal women to compete with gods
    in form and beauty.”
    Resourceful Odysseus then answered her and said:
    “Mighty goddess,
    do not be angry with me over this.
    I myself know very well Penelope,
    although intelligent, is not your match
270
    to look at, not in stature or in beauty.
    But she’s a human being and you’re a god.
    You’ll never die or age. But still I wish,
    every moment to get back to my home,
    to see the day of my return. And so,
    even if out there on the wine-dark sea
    some god breaks me apart, I will go on—
    the heart here in my chest is quite prepared
    to bear affliction. I’ve already had
    so many troubles, and I’ve worked so hard
280
    through waves and warfare. Let what’s yet to come
    be added in with those.


(Attribution: Homer. “The Odyssey”, Book 5)`,
      assessment_instructions: "",
    },
  },
  {
    language: "English",
    title: `Mastering English root words`,
    template_type: "assessment",
    includeUserGroups: ["all"],
    // Exclude takes precedence over include
    excludeUserGroups: ["bt-testing", "bt-ctx"],
    formData: {
      subject: "English",
      grade: "Grade 6",
      show_text: "Closed book",
      questions: {
        mc_quantity: 5,
        ff_quantity: 3,
        tf_quantity: 5,
        fb_quantity: 5,
        mc_options: 4,
        skills: {
          knowledge: false,
          analysis: true,
          comprehension: true,
          application: true,
        },
      },
      difficulty_level: "Medium",
      genre: "List of terms (eg: lesson plan, terms, syllabus, notes, etc)",
      text: `Aqua
Bio
Chrono
Geo
Graph
Meter
Micro
Photo
Port
Scope
Tele
Therm
Auto
Cred
Dict`,
      assessment_instructions:
        "Using these root words, create fictional words by combining two or more root words and craft a test to assess students’ ability to deduce meanings.",
    },
  },
];

export const readingComprehensionFormExamples = [
  // Note: contributorId comes from the "Contributor profiles" db on the backend
  {
    contributorId: 12,
    language: "English",
    title: "Apple Inc.: from garage startup to tech giant - grade 4",
    template_type: "reading",
    includeUserGroups: [
      "cy-rav",
      "cy-sj",
      "cy-testing"
    ],
    excludeUserGroups: [],
    formData: {
      subject: "English",
      grade: "Grade 4",
      show_text: "Open book",
      length: "250 to 500 words",
      questions: {
        ff_quantity: 5,
        mc_options: 4,
        mc_quantity: 0,
        tf_quantity: 0,
        fb_quantity: 0,
        skills: {
          analysis: true,
          structure: true,
          theme: true,
          tone: true,
          vocabulary: true
        },
        question_scope_passage_only: true
      },
      difficulty_level: "Hard",
      genre: "Informational Text",
      text: "Talk about how Apple started out in a garage and how eventually they are what we know today",
      assessment_instructions: "",
      text_instructions: ""
    },
    includeImages: false,
    includeParagraphNumbers: false
  },
  {
    contributorId: 11,
    language: "English",
    title: "Testing comprehension with familiar references",
    template_type: "reading",
    includeUserGroups: [
      "cy-rav",
      "cy-sj",
      "cy-testing"
    ],
    excludeUserGroups: [],
    formData: {
      subject: "English",
      grade: "Grade 5",
      show_text: "Open book",
      length: "500 to 750 words",
      questions: {
        ff_quantity: 1,
        mc_options: 4,
        mc_quantity: 3,
        tf_quantity: 3,
        fb_quantity: 3,
        skills: {
          analysis: true,
          structure: true,
          theme: true,
          tone: true,
          vocabulary: true
        },
        question_scope_passage_only: true
      },
      difficulty_level: "Easy",
      genre: "Realistic Fiction",
      text: "A story about 5th grade elementary students going on an adventure to find the missing numbers 6 and 7. ",
      assessment_instructions: "",
      text_instructions: ""
    },
    includeImages: true,
    includeParagraphNumbers: true
  },
  {
    contributorId: 10,
    language: "English",
    title: "Halloween holiday origins",
    template_type: "reading",
    includeUserGroups: [
      "cy-rav",
      "cy-sj",
      "cy-testing"
    ],
    excludeUserGroups: [],
    formData: {
      subject: "English",
      grade: "Grade 5",
      show_text: "Open book",
      length: "250 to 500 words",
      questions: {
        ff_quantity: 3,
        mc_options: 4,
        mc_quantity: 3,
        tf_quantity: 3,
        fb_quantity: 3,
        skills: {
          analysis: true,
          structure: true,
          theme: true,
          tone: true,
          vocabulary: true
        },
        question_scope_passage_only: true
      },
      difficulty_level: "Medium",
      genre: "Informational Text",
      text: "Write about how Halloween started.",
      assessment_instructions: "",
      text_instructions: ""
    },
    includeImages: true,
    includeParagraphNumbers: false
  },
  {
    contributorId: 3,
    language: "English",
    title: "Third grade safari to learn about fruit bats",
    template_type: "reading",
    includeUserGroups: [
      "cy-rav",
      "cy-sj",
      "cy-testing"
    ],
    excludeUserGroups: [],
    formData: {
      subject: "English",
      grade: "Grade 3",
      show_text: "Open book",
      length: "250 to 500 words",
      questions: {
        ff_quantity: 5,
        mc_options: 4,
        mc_quantity: 5,
        tf_quantity: 0,
        fb_quantity: 0,
        skills: {
          analysis: true,
          structure: false,
          theme: false,
          tone: false,
          vocabulary: true
        },
        question_scope_passage_only: true
      },
      difficulty_level: "Medium",
      genre: "Informational Text",
      text: "Kamila and Katalina are on a safari in Australia to learn about the fruit bat. Explain some interesting facts about the fruit bat. ",
      assessment_instructions: "",
      text_instructions: ""
    },
    includeImages: true,
    includeParagraphNumbers: true
  },
  {
  contributorId: 8,
  language: "English",
  title: "Alternative to lecturing! Solar ovens - text/Kahoot - grade 7",
  template_type: "reading",
  includeUserGroups: [ "bt-testing", "bt-ctx" ],
  excludeUserGroups: [],
  formData: {
    subject: "Science",
    grade: "Grade 7",
    show_text: "Open book",
    length: "250 to 500 words",
    questions: {
      ff_quantity: 2,
      mc_options: 4,
      mc_quantity: 5,
      tf_quantity: 3,
      fb_quantity: 3,
      skills: {
        analysis: true,
        structure: true,
        theme: true,
        tone: false,
        vocabulary: true
      }
    },
    difficulty_level: "Medium",
    genre: "Informational Text",
    text: `I’m teaching a unit on [solar ovens and their connection to deforestation and global climate change].

Focus: [what solar ovens are, what deforestation is and how they both related to climate change]`,
    assessment_instructions: "",
    text_instructions: `Summary: [In this lesson, students explore the impact of deforestation on the global climate, as well as some of the specific
difficulties facing indigenous people living in forested regions. They learn how the UN-REDD program is addressing
some of these difficulties by providing sustainable solutions. They then hone in on a simple tool—the solar oven—                                                                                    and explore how it is making a difference for many people living in remote regions of the world. Students take a
close look at various solar oven designs and discuss the strengths and weaknesses of each before building their
own solar oven and testing its effectiveness.]

Learning Objectives: [Analyze the causes and consequences of
deforestation.
Describe the advantages of using a solar oven to
harness solar radiation.
Analyze the strengths and weaknesses of
different solar oven designs.
Construct a working solar oven and consider
various design improvements.]

Key Vocabulary: [Deforestation, solar energy, solar radiation, energy
transfer, radiation, convection, conduction, solar
oven]`
  },
  includeImages: true,
  includeParagraphNumbers: false
},
  {
  contributorId: 9,
  language: "English",
  title: "Fun little article about biology for low attention span kids - grade 9",
  template_type: "reading",
  includeUserGroups: [ "bt-testing", "bt-ctx" ],
  excludeUserGroups: [],
  formData: {
    subject: "Science",
    grade: "Grade 9",
    show_text: "Open book",
    length: "100 to 250 words",
    questions: {
      ff_quantity: 3,
      mc_options: 4,
      mc_quantity: 3,
      tf_quantity: 3,
      fb_quantity: 3,
      skills: {
        analysis: true,
        structure: true,
        theme: true,
        tone: false,
        vocabulary: true
      }
    },
    difficulty_level: "Medium",
    genre: "Scientific Article",
    text: "An intro to Biology for low attention span kids that need plenty of fun activities.\r\nfocus: Start with animals and ecosystems",
    assessment_instructions: "",
    text_instructions: "include fun activities to get the students moving"
  },
  includeImages: true,
  includeParagraphNumbers: true
},
  {
    contributorId: 2,
    language: "English",
    title: "Personalized story: how to handle failure - grade 5",
    template_type: "reading",
    includeUserGroups: [
      "cy-rav",
      "cy-sj",
      "cy-testing"
    ],
    excludeUserGroups: [],
    formData: {
      subject: "English",
      grade: "Grade 5",
      show_text: "Open book",
      length: "1,000 to 1,500 words",
      questions: {
        ff_quantity: 5,
        mc_options: 4,
        mc_quantity: 0,
        tf_quantity: 0,
        fb_quantity: 0,
        skills: {
          analysis: true,
          structure: true,
          theme: true,
          tone: true,
          vocabulary: true
        }
      },
      difficulty_level: "Medium",
      genre: "Realistic Fiction",
      text: "Cameron and Angel train the hardest they've ever had in their life to secure the championship game in the basketball tournament. They're a part of the Costaño Cougars basketball team. It was a close game but they lose to a buzzer beater three pointer from the other team. They learn the lesson of accepting defeat and grit to keep pushing even when they are faced with adversity.",
      assessment_instructions: "",
      text_instructions: ""
    },
    includeImages: false,
    includeParagraphNumbers: true
  },
  {
    contributorId: 5,
    language: "English",
    title: "Fraction comparison using a number line - grade 5",
    template_type: "reading",
    includeUserGroups: [
      "cy-rav",
      "cy-sj",
      "cy-testing"
    ],
    excludeUserGroups: [],
    formData: {
      subject: "Other",
      grade: "Grade 5",
      show_text: "Open book",
      length: "500 to 750 words",
      questions: {
        ff_quantity: 3,
        mc_options: 4,
        mc_quantity: 5,
        tf_quantity: 5,
        fb_quantity: 0,
        skills: {
          analysis: true,
          structure: false,
          theme: false,
          tone: false,
          vocabulary: true
        }
      },
      difficulty_level: "Easy",
      genre: "Informational Text",
      text: "Explain how to compare fractions using a number line and using the benchmark fraction 1/2",
      assessment_instructions: "",
      text_instructions: ""
    },
    includeImages: false,
    includeParagraphNumbers: false
  },
  {
    contributorId: 7,
    language: "English",
    title: "Pokémon learning to listen - grade 2",
    template_type: "reading",
    includeUserGroups: [
      "cy-rav",
      "cy-sj",
      "cy-testing"
    ],
    excludeUserGroups: [],
    formData: {
      subject: "English",
      grade: "Grade 2",
      show_text: "Open book",
      length: "100 to 250 words",
      questions: {
        ff_quantity: 0,
        mc_options: 4,
        mc_quantity: 5,
        tf_quantity: 1,
        fb_quantity: 0,
        skills: {
          analysis: true,
          structure: true,
          theme: true,
          tone: true,
          vocabulary: true
        }
      },
      difficulty_level: "Easy",
      genre: "Fantasy",
      text: "Generate a text about Pokémon learning how to listen to their Pokémon trainer.",
      assessment_instructions: "",
      text_instructions: ""
    },
    includeImages: true,
    includeParagraphNumbers: false
  },
  {
    contributorId: 6,
    language: "English",
    title: "Sea-exploring adventure - hard",
    template_type: "reading",
    includeUserGroups: [
      "cy-rav",
      "cy-sj",
      "cy-testing"
    ],
    excludeUserGroups: [],
    formData: {
      subject: "English",
      grade: "Grade 5",
      show_text: "Open book",
      length: "1,000 to 1,500 words",
      questions: {
        ff_quantity: 3,
        mc_options: 4,
        mc_quantity: 5,
        tf_quantity: 5,
        fb_quantity: 5,
        skills: {
          analysis: true,
          structure: true,
          theme: true,
          tone: true,
          vocabulary: true
        }
      },
      difficulty_level: "Hard",
      genre: "Science Fiction",
      text: "The girl students are Mikaela, Lauren, and Soli. The boy students are Julian and Moises. The story is an adventure about exploring the sea.",
      assessment_instructions: "",
      text_instructions: ""
    },
    includeImages: false
  },
  {
    contributorId: 5,
    language: "English",
    title: "Suffixes in a story about boys and girls working together",
    template_type: "reading",
    includeUserGroups: [
      "cy-rav",
      "cy-sj",
      "cy-testing"
    ],
    excludeUserGroups: [],
    formData: {
      subject: "Other",
      grade: "Grade 5",
      show_text: "Open book",
      length: "250 to 500 words",
      questions: {
        ff_quantity: 3,
        mc_options: 4,
        mc_quantity: 5,
        tf_quantity: 5,
        fb_quantity: 5,
        skills: {
          analysis: true,
          structure: true,
          theme: true,
          tone: false,
          vocabulary: true
        }
      },
      difficulty_level: "Medium",
      genre: "Realistic Fiction",
      text: "Tell a story about a time where working together despite their gender (girls vs. boys), like in sports, actually made things easier and more fun. Include specific stereotypes that are usually used against specific genders.",
      assessment_instructions: "",
      text_instructions: "Bolden words ending with the suffixes: -ion, -tion, -ation, -er/-or"
    },
    includeImages: true
  },
  {
    contributorId: 5,
    language: "English",
    title: "Teach fraction comparison using a story",
    template_type: "reading",
    includeUserGroups: [
      "cy-rav",
      "cy-sj",
      "cy-testing"
    ],
    excludeUserGroups: [],
    formData: {
      subject: "Other",
      grade: "Grade 5",
      show_text: "Open book",
      length: "250 to 500 words",
      questions: {
        ff_quantity: 3,
        mc_options: 4,
        mc_quantity: 5,
        tf_quantity: 5,
        fb_quantity: 5,
        skills: {
          analysis: true,
          structure: true,
          theme: true,
          tone: false,
          vocabulary: true
        }
      },
      difficulty_level: "Medium",
      genre: "Informational Text",
      text: "Use a story to explain how to compare fractions",
      assessment_instructions: "",
      text_instructions: ""
    },
    includeImages: true
  },
  {
    contributorId: 6,
    language: "English",
    title: "Tectonic plates and volcanoes: a personalized class adventure",
    template_type: "reading",
    includeUserGroups: [
      "cy-rav",
      "cy-sj",
      "cy-testing"
    ],
    excludeUserGroups: [],
    formData: {
      subject: "English",
      grade: "Grade 4",
      show_text: "Open book",
      length: "1,000 to 1,500 words",
      questions: {
        ff_quantity: 1,
        mc_options: 4,
        mc_quantity: 5,
        tf_quantity: 5,
        fb_quantity: 5,
        skills: {
          analysis: false,
          structure: false,
          theme: true,
          tone: true,
          vocabulary: true
        }
      },
      difficulty_level: "Medium",
      genre: "Science Fiction",
      text: "Ms. Gomez's class goes on an adventure to learn about tectonic plates and volcanoes for their geology class. Include the names; the girls are Lauren, Soli, and Mikaela. The boys are Moises and Julian.",
      assessment_instructions: "",
      text_instructions: ""
    },
    includeImages: false
  },
  {
    contributorId: 5,
    language: "English",
    title: "Focus on \"not\" and \"position\" family prefixes in a passage",
    template_type: "reading",
    includeUserGroups: [
      "cy-rav",
      "cy-sj",
      "cy-testing"
    ],
    excludeUserGroups: [],
    formData: {
      subject: "English",
      grade: "Grade 5",
      show_text: "Open book",
      length: "100 to 250 words",
      questions: {
        ff_quantity: 2,
        mc_options: 4,
        mc_quantity: 5,
        tf_quantity: 3,
        fb_quantity: 3,
        skills: {
          analysis: false,
          structure: false,
          theme: false,
          tone: false,
          vocabulary: true
        }
      },
      difficulty_level: "Hard",
      genre: "Realistic Fiction",
      text: "Create a passage about how someone encounters a challenge and how they overcome it. Use and bolden prefixes from the \"not\" and \"position\" family (un-, dis-, in-/ im-, non-, pre-, fore-, mid-, inter-, post-)",
      text_instructions: "",
      assessment_instructions: "Only focus on the boldened vocab words - the prefix and base of each word. Discuss which word is a real word and explain how they know"
    },
    includeImages: true,
  },
  {
    contributorId: 4,
    language: "English",
    title: "Missing Stanley cup in the classroom",
    template_type: "reading",
    includeUserGroups: ["cy-rav", "cy-sj", "cy-testing"],
    // Exclude takes precedence over include
    excludeUserGroups: [],

    formData: {
      subject: "English",
      grade: "Grade 4",
      show_text: "Open book",
      length: "250 to 500 words",
      questions: {
        mc_quantity: 5,
        ff_quantity: 3,
        tf_quantity: 0,
        fb_quantity: 2,
        mc_options: 4,
        skills: {
          theme: true,
          analysis: true,
          vocabulary: true,
          structure: true,
          tone: true,
        },
      },
      difficulty_level: "Medium",
      genre: "Realistic Fiction",

      text: `Write a story about a Stanley cup going missing in the classroom.\r\ninclude the names: Soila, Aacelia, gabby, Allison, Thien an, Eliana, Jordyn\r\n\r\nSchool name: Cassel Elementary School\r\nTeacher Name: Ms. Vanessa`,
      text_instructions: "",
      assessment_instructions: "",
    },
    includeImages: true,
  },
  {
    contributorId: 2,
    language: "English",
    title: "Using a full story as context for a continuation",
    template_type: "reading",
    includeUserGroups: ["cy-rav", "cy-sj", "cy-testing"],
    // Exclude takes precedence over include
    excludeUserGroups: [],

    formData: {
      subject: "English",
      grade: "Grade 5",
      show_text: "Closed book",
      length: "500 to 750 words",
      questions: {
        mc_quantity: 0,
        ff_quantity: 5,
        tf_quantity: 0,
        fb_quantity: 0,
        mc_options: 4,
        skills: {
          knowledge: true,
          analysis: true,
          application: true,
          comprehension: true
        },
      },
      difficulty_level: "Easy",
      genre: "Fantasy",
      text: "Can you make a continuation of this story and help them solve their mystery\n\r\n\rThe Potion's Peculiar Peril \r\n\r\n[par.1] Sao and Kacy exchanged nervous glances as they stood outside the school gates, feeling a thrill race through their veins. The previous evening, hidden away in the musty confines of Sao's attic, the two friends had discovered an ancient-looking potion. \"This will make us the smartest kids in school,\" Kacy had declared with a grin, her eyes wide with excitement.\r\n\r\n[par.2] Now, armed with newfound confidence, they walked into their first class, Math, their heads held high. \"Let's see how this works,\" Sao whispered as they slid into their seats.\r\n\r\n[par.3] As Mr. Duncan scratched a complex equation across the board, both Sao and Kacy found the answer immediately leaping into their minds. Their hands shot up in unison.\r\n\r\n[par.4] \"Yes, Sao?\" Mr. Duncan asked, eyebrows raised.\r\n\r\n[par.5] \"The answer is 7x,\" Sao replied, confidently solving the equation. Mr. Duncan nodded, looking impressed, and the rest of the class exchanged surprised glances.\r\n\r\n[par.6] With each lesson, their intelligence flourished. During history, they recited facts from memory. In science, they explained theories even Mr. Duncan had to google to confirm. Everything was going great—until lunchtime.\r\n\r\n[par.7] As they sat down with their sandwiches, Sao suddenly stood up. \"Did you know that bread predates recorded history and was likely invented around 8,000 years ago?\" she blurted out, a puzzled look crossing her face.\r\n\r\n[par.8] \"Uh, Sao?\" Kacy mumbled, trying to tug her back down into her seat.\r\n\r\n[par.9] Before Sao could sit, Kacy's mouth opened again without her control. \"Wait, Sao, that’s nothing compared to how your digestive system processes it. Did you know that digestion starts in the mouth with enzymes called amylase?\" her words came out fast and unwelcome.\r\n\r\n[par.10] Panic slowly seeped into their thoughts. It seemed they couldn’t stop themselves from saying every thought that crossed their minds.\r\n\r\n[par.11] The situation worsened throughout the day: biology was filled with unexpected facts on plant cells, and during recess, they gave a random lesson on the phases of the moon. Fellow students started avoiding them, giggling, or staying silent in discomfort.\r\n\r\n[par.12] After school, they huddled in the library, surrounded by towering bookshelves. \"This is bad, Kacy,\" Sao hissed, trying to keep her voice down. \"We can't keep blurting out everything, or we'll never have friends again!\"\r\n\r\n[par.13] Kacy nodded, eyes wide with worry. \"The potion must've done something to our brains! We've got to fix this, but how?\" She glanced at the potion bottle peeking out of Sao's backpack.\r\n\r\n[par.14] Sao sighed, feeling the weight of their predicament. \"We need a plan. Maybe there's something in the attic, a book or a map. Anything that can help us.\"\r\n\r\n[par.15] \"Let's meet tonight,\" Kacy agreed, determination replacing her fear. \"We’ll figure this out together.\"\r\n\r\n[par.16] The two kids were at a crossroads, and as the shadows of the library lengthened, they knew they had a new mystery on their hands—a mystery that required all their wits, without the potion's help.",
      text_instructions: "",
      assessment_instructions: "",
    },
    includeImages: false,
  },
  {
    contributorId: 2,
    language: "English",
    title: "Continuing the plot of a previous story",
    template_type: "reading",
    includeUserGroups: ["cy-rav", "cy-sj", "cy-testing"],
    // Exclude takes precedence over include
    excludeUserGroups: [],

    formData: {
      subject: "English",
      grade: "Grade 5",
      show_text: "Closed book",
      length: "500 to 750 words",
      questions: {
        mc_quantity: 0,
        ff_quantity: 5,
        tf_quantity: 0,
        fb_quantity: 0,
        mc_options: 4,
        skills: {
          knowledge: true,
          analysis: true,
          application: true,
          comprehension: true
        },
      },
      difficulty_level: "Easy",
      genre: "Mystery",
      text: `Both sao and kacy drank a portion that made them the smartest kids in school? But will this plan back fire on them? write the story as a continuation from a previous one where they already found the potion`,
      text_instructions: "",
      assessment_instructions: "",
    },
    includeImages: false,
  },
  {
    contributorId: 0,
    language: "English",
    title: "Create a text based on a lesson plan (very relatable)",
    template_type: "reading",
    includeUserGroups: [],
    // Exclude takes precedence over include
    excludeUserGroups: [],

    formData: {
      subject: "Science",
      grade: "Grade 6",
      show_text: "Closed book",
      length: "250 to 500 words",
      questions: {
        mc_quantity: 5,
        ff_quantity: 3,
        tf_quantity: 5,
        fb_quantity: 0,
        mc_options: 4,
        skills: {
          knowledge: true,
          analysis: true,
          application: true,
          comprehension: true
        },
      },
      difficulty_level: "Medium",
      genre: "Personal Narrative",
      text: `I’m teaching a unit on [organic/inorganic garbage and waste management]. Create a story for use as part of a [gallery walk] classroom activity.  Make the text fun, relatable and captivating for my [6th grade] students. [Use some lively dialog].\r\nI want the story to be so intriguing that they want to continue reading until the end.\r\n`,
      text_instructions: "Here is the lesson plan: <insert your lesson plan here>\r\n\r\nFor this story, focus specifically on the following learning objectives: <insert your learning objectives here>",
      assessment_instructions: "",
      server_file_group: "bt-energy-files-1",
    },
    includeImages: true,
  },
  {
    contributorId: 0,
    language: "English",
    title: "Create a text based on a lesson plan (informative)",
    template_type: "reading",
    includeUserGroups: [],
    // Exclude takes precedence over include
    excludeUserGroups: [],

    formData: {
      subject: "Science",
      grade: "Grade 6",
      show_text: "Closed book",
      length: "250 to 500 words",
      questions: {
        mc_quantity: 5,
        ff_quantity: 3,
        tf_quantity: 5,
        fb_quantity: 0,
        mc_options: 4,
        skills: {
          knowledge: true,
          analysis: true,
          application: true,
          comprehension: true
        },
      },
      difficulty_level: "Medium",
      genre: "Informational Text",
      text: `I’m teaching a unit on [organic/inorganic garbage and waste management]. Create an informative text for use as part of a [gallery walk] classroom activity. \r\n`,
      text_instructions: "Here is the lesson plan: <insert your lesson plan here>\r\n\r\nFor this text, focus specifically on the following learning objectives: <insert your learning objectives here>",
      assessment_instructions: "",
      server_file_group: "bt-energy-files-1",
    },
    includeImages: true,
  },

  {
    contributorId: 0,
    language: "English",
    title: "Create a text based on a lesson plan (op-ed)",
    template_type: "reading",
    includeUserGroups: [],
    // Exclude takes precedence over include
    excludeUserGroups: [],

    formData: {
      subject: "Science",
      grade: "Grade 6",
      show_text: "Closed book",
      length: "250 to 500 words",
      questions: {
        mc_quantity: 5,
        ff_quantity: 3,
        tf_quantity: 5,
        fb_quantity: 0,
        mc_options: 4,
        skills: {
          knowledge: true,
          analysis: true,
          application: true,
          comprehension: true
        },
      },
      difficulty_level: "Medium",
      genre: "Newspaper Article (op-ed)",
      text: `I’m teaching a unit on [organic/inorganic garbage and waste management]. Create an informative, yet engaging article for use as part of a [gallery walk] classroom activity. Make the text relatable for my [6th grade] students.  \r\n`,
      text_instructions: "Here is the lesson plan: <insert your lesson plan here>\r\n\r\nFor this article, focus specifically on the following learning objectives: <insert your learning objectives here>",
      assessment_instructions: "",
    },
    includeImages: true,
  },
  {
    contributorId: 0,
    language: "English",
    title: "Debate Arguments - Group 1. (scholarly)",
    template_type: "reading",
    includeUserGroups: [],
    // Exclude takes precedence over include
    excludeUserGroups: [],

    formData: {
      subject: "Science",
      grade: "Grade 8",
      show_text: "Closed book",
      length: "500 to 750 words",
      questions: {
        mc_quantity: 0,
        ff_quantity: 3,
        tf_quantity: 0,
        fb_quantity: 0,
        mc_options: 4,
        skills: {
          knowledge: true,
          analysis: true,
          application: true,
          comprehension: true
        },
      },
      difficulty_level: "Medium",
      genre: "Excerpt from a Scholarly Paper",
      text: `I’m teaching a unit on [energy fundamentals]. Create an article for a classroom debate. Write a scholarly text that argues [in favor of renewable energy].\r\n`,
      text_instructions: "Here is the lesson plan for this unit: <insert your lesson plan here>\r\n\r\n",
      assessment_instructions: "",
    },
    includeImages: true,
  },
  {
    contributorId: 0,
    language: "English",
    title: "Debate Arguments - Group 2. (somewhat relatable)",
    template_type: "reading",
    includeUserGroups: [],
    // Exclude takes precedence over include
    excludeUserGroups: [],

    formData: {
      subject: "Science",
      grade: "Grade 8",
      show_text: "Closed book",
      length: "500 to 750 words",
      questions: {
        mc_quantity: 0,
        ff_quantity: 3,
        tf_quantity: 0,
        fb_quantity: 0,
        mc_options: 4,
        skills: {
          knowledge: true,
          analysis: true,
          application: true,
          comprehension: true
        },
      },
      difficulty_level: "Medium",
      genre: "Newspaper Article (op-ed)",
      text: `I’m teaching a unit on [energy fundamentals]. Create an article for a classroom debate. Write a strong op-ed article that argues [in favor of fossil fuels].\r\nMake the text relatable for my [8th grade] students. \r\n`,
      text_instructions: "Here is the lesson plan for this unit: <insert your lesson plan here>\r\n\r\n",
      assessment_instructions: "",
    },
    includeImages: true,
  },
  {
    contributorId: 0,
    language: "English",
    title: "Debate Rebuttal - Group 1. (scholarly)",
    template_type: "reading",
    includeUserGroups: [],
    // Exclude takes precedence over include
    excludeUserGroups: [],

    formData: {
      subject: "Science",
      grade: "Grade 8",
      show_text: "Closed book",
      length: "500 to 750 words",
      questions: {
        mc_quantity: 0,
        ff_quantity: 3,
        tf_quantity: 0,
        fb_quantity: 0,
        mc_options: 4,
        skills: {
          knowledge: true,
          analysis: true,
          application: true,
          comprehension: true
        },
      },
      difficulty_level: "Medium",
      genre: "Excerpt from a Scholarly Paper",
      text: `You are participating in a debate. Your position is that [people should move to renewable energy and keep using fossil fuels]. Write a rebuttal to the attached debate argument which argues [in favor of fossil fuels].\r\nWrite in a scholarly style.\r\n`,
      text_instructions: "Here is the debate argument from the [pro fossil fuels group]: <insert debate Arguments from Group 2 here> \r\n\r\n",
      assessment_instructions: "",
    },
    includeImages: true,
  },
  {
    contributorId: 0,
    language: "English",
    title: "Debate Rebuttal - Group 2. (somewhat relatable)",
    template_type: "reading",
    includeUserGroups: [],
    // Exclude takes precedence over include
    excludeUserGroups: [],

    formData: {
      subject: "Science",
      grade: "Grade 8",
      show_text: "Closed book",
      length: "500 to 750 words",
      questions: {
        mc_quantity: 0,
        ff_quantity: 3,
        tf_quantity: 0,
        fb_quantity: 0,
        mc_options: 4,
        skills: {
          knowledge: true,
          analysis: true,
          application: true,
          comprehension: true
        },
      },
      difficulty_level: "Medium",
      genre: "Newspaper Article (op-ed)",
      text: `You are participating in a debate. Your position is [that people should use fossil fuels and not move to renewable energy]. Write a rebuttal to the attached debate argument which argues [in favor of renewable energy].\r\nMake the text relatable for my 8th grade students. \r\n`,
      text_instructions: "Here is the debate argument from the [pro-renewable energy] group: <insert debate Arguments from Group 1 here> \r\n\r\n",
      assessment_instructions: "",
    },
    includeImages: true,
  },
  {
    contributorId: 0,
    language: "English",
    title: "Create a text based on a lesson plan",
    template_type: "reading",
    includeUserGroups: [
      "bt-testing", "bt-ctx"
    ],
    excludeUserGroups: [],
    formData: {
      subject: "Science",
      grade: "Grade 7",
      show_text: "Closed book",
      length: "250 to 500 words",
      questions: {
        ff_quantity: 3,
        mc_options: 4,
        mc_quantity: 5,
        tf_quantity: 3,
        fb_quantity: 3,
        skills: {
          analysis: true,
          application: true,
          comprehension: true,
          knowledge: true
        }
      },
      difficulty_level: "Medium",
      genre: "Informational Text",
      text: `I’m teaching a unit on [insert topic, eg Wonderful Worms].

Focus: [insert a brief description, eg Compare linear to circular systems]`,
      assessment_instructions: "",
      text_instructions: `Summary: [insert Summary from lesson plan]

Learning Objectives: [insert Objectives from lesson plan]

Key Vocabulary: [insert Key Vocabulary from lesson plan]`
    },
    includeImages: true,
    includeParagraphNumbers: false
  },
  {
    language: "English",
    title: "Create a text on a topic using specific vocab (relatable)",
    template_type: "reading",
    includeUserGroups: ["bt-testing", "bt-ctx"],
    // Exclude takes precedence over include
    excludeUserGroups: [],

    formData: {
      subject: "Science",
      grade: "Grade 6",
      show_text: "Closed book",
      length: "250 to 500 words",
      questions: {
        mc_quantity: 5,
        ff_quantity: 3,
        tf_quantity: 5,
        fb_quantity: 5,
        mc_options: 4,
        skills: {
          knowledge: true,
          analysis: true,
          application: true,
          comprehension: true
        },
      },
      difficulty_level: "Medium",
      genre: "Newspaper Article",
      text: "Write a text using as many of the following vocab words as possible: [insert vocab list]\r\n\r\nMake the text informative, yet keep it fun and relatable for my students.\r\n\r\nSetting: [eg Del Valle middle school, students: Maria, Evan, Joshua]",
      text_instructions: "Bold the vocab words in the passage",
      assessment_instructions: "",
    },
    includeImages: true,
    includeParagraphNumbers: false
  },
  {
    contributorId: 3,
    language: "English",
    title: "Grade 2 crazy robot story",
    template_type: "reading",
    includeUserGroups: ["cy-rav", "cy-sj", "cy-testing"],
    // Exclude takes precedence over include
    excludeUserGroups: [],

    formData: {
      subject: "English",
      grade: "Grade 2",
      show_text: "Open book",
      length: "100 to 250 words",
      questions: {
        mc_quantity: 5,
        ff_quantity: 3,
        tf_quantity: 5,
        fb_quantity: 5,
        mc_options: 4,
        skills: {
          theme: true,
          analysis: true,
          vocabulary: true,
          structure: true,
          tone: true,
        },
      },
      difficulty_level: "Medium",
      genre: "Mystery",
      text: `Write a story about a crazy robot that goes out of control. Include 4 kids named Samantha, Ivan, Amy, and Belinda who are trying to figure out why the robot is broken.`,
      text_instructions: "",
      assessment_instructions: "",
    },
    includeImages: true,
  },
  {
    contributorId: 2,
    language: "English",
    title: "Grade 5 secret intelligence potion story",
    template_type: "reading",
    includeUserGroups: ["cy-rav", "cy-sj", "cy-testing"],
    // Exclude takes precedence over include
    excludeUserGroups: [],

    formData: {
      subject: "English",
      grade: "Grade 5",
      show_text: "Closed book",
      length: "500 to 750 words",
      questions: {
        mc_quantity: 0,
        ff_quantity: 5,
        tf_quantity: 0,
        fb_quantity: 0,
        mc_options: 4,
        skills: {
          knowledge: true,
          analysis: true,
          application: true,
          comprehension: true
        },
      },
      difficulty_level: "Easy",
      genre: "Realistic Fiction",
      text: `Sao finds a potion that makes him the smartest kid in school. Kacy, a girl that was walking by notices. Sao now has a secret he cant tell anyone. What will Kacy do?`,
      text_instructions: "",
      assessment_instructions: "",
    },
  },
  {
    contributorId: 3,
    language: "English",
    title: "Grade 2 personalized painting story",
    template_type: "reading",
    includeUserGroups: ["cy-rav", "cy-sj", "cy-testing"],
    // Exclude takes precedence over include
    excludeUserGroups: [],

    formData: {
      subject: "English",
      grade: "Grade 2",
      show_text: "Open book",
      length: "100 to 250 words",
      questions: {
        mc_quantity: 5,
        ff_quantity: 3,
        tf_quantity: 5,
        fb_quantity: 5,
        mc_options: 4,
        skills: {
          theme: true,
          analysis: true,
          vocabulary: true,
          structure: true,
          tone: true,
        },
      },
      difficulty_level: "Easy",
      genre: "Realistic Fiction",
      text: `Write a story about 4 girls named Anel, Emery, Kenzie, and Emmy learning to paint different animals.`,
      text_instructions: "add some vocab words to focus on",
      assessment_instructions: "",
    },
    includeImages: true,
  },
  {
    contributorId: 2,
    language: "English",
    title: "Grade 5 personalized holiday-themed story",
    template_type: "reading",
    includeUserGroups: ["cy-rav", "cy-sj", "cy-testing"],
    // Exclude takes precedence over include
    excludeUserGroups: [],

    formData: {
      subject: "English",
      grade: "Grade 5",
      show_text: "Closed book",
      length: "500 to 750 words",
      questions: {
        mc_quantity: 0,
        ff_quantity: 5,
        tf_quantity: 0,
        fb_quantity: 0,
        mc_options: 4,
        skills: {
          knowledge: true,
          analysis: true,
          application: true,
          comprehension: true
        },
      },
      difficulty_level: "Easy",
      genre: "Mystery",
      text: `Make a story with Kacy and Sao as protagonists. The theme should be holiday themed.`,
      text_instructions: "",
      assessment_instructions: "",
    },
  },
  {
    contributorId: 2,
    language: "English",
    title: "Personalized mystery story",
    template_type: "reading",
    includeUserGroups: ["cy-rav", "cy-sj", "cy-testing"],
    // Exclude takes precedence over include
    excludeUserGroups: [],

    formData: {
      subject: "English",
      grade: "Grade 5",
      show_text: "Closed book",
      length: "500 to 750 words",
      questions: {
        mc_quantity: 0,
        ff_quantity: 5,
        tf_quantity: 0,
        fb_quantity: 0,
        mc_options: 4,
        skills: {
          knowledge: true,
          analysis: true,
          application: true,
          comprehension: true
        },
      },
      difficulty_level: "Easy",
      genre: "Mystery",
      text: `Angel, the Costano Cougars soccer star and Cameron, the schools smartest kid team up to solve the schools biggest mystery.`,
      text_instructions: "",
      assessment_instructions: "",
    },
  },
  {
    contributorId: 2,
    language: "English",
    title: "School mural story",
    template_type: "reading",
    includeUserGroups: ["cy-rav", "cy-sj", "cy-testing"],
    // Exclude takes precedence over include
    excludeUserGroups: [],

    formData: {
      subject: "English",
      grade: "Grade 5",
      show_text: "Open book",
      length: "500 to 750 words",
      questions: {
        mc_quantity: 0,
        ff_quantity: 5,
        tf_quantity: 0,
        fb_quantity: 0,
        mc_options: 4,
        skills: {
          theme: true,
          analysis: true,
          vocabulary: true,
          structure: true,
          tone: true,
        },
      },
      difficulty_level: "Easy",
      genre: "Science Fiction",
      text: `Cameron and Angel find a map in the schools sand box after following some clues for the schools murals. They will embark on a journey to find a special necklace that has cursed the Costano Cougars for so long. The curse of Costano.`,
      text_instructions: "",
      assessment_instructions: "",
    },
  },

  {
    language: "English",
    title: "Explain the forces of motion and gravity to a basketball lover",
    template_type: "reading",
    includeUserGroups: ["all"],
    // Exclude takes precedence over include
    excludeUserGroups: [],

    formData: {
      subject: "Science",
      grade: "Grade 6",
      show_text: "Open book",
      length: "250 to 500 words",
      questions: {
        mc_quantity: 5,
        ff_quantity: 3,
        tf_quantity: 5,
        fb_quantity: 5,
        mc_options: 4,
        skills: {
          theme: true,
          analysis: true,
          vocabulary: true,
          structure: true,
          tone: true,
        },
      },
      difficulty_level: "Medium",
      genre: "Informational Text",
      text: "Write a fun and relatable science article for middle schoolers that grabs the attention of 6th graders. Explain the laws of motion and gravity through a conversation between Luke and his hero, Steph Curry. Maybe Luke challenges Steph to a basketball game—can he beat him? Make sure to explain how gravity and motion affect basketball in a simple way, but keep it fun and full of lively dialogue!",
      text_instructions: "",
      assessment_instructions: "",
    },
  },
  {
    language: "English",
    title: "Introducing students to the Harlem Renaissance",
    template_type: "reading",
    includeUserGroups: ["all"],
    // Exclude takes precedence over include
    excludeUserGroups: ["cy-rav", "cy-sj", "cy-testing", "bt-testing", "bt-ctx"],

    formData: {
      subject: "History",
      grade: "Grade 9",
      show_text: "Closed book",
      length: "750 to 1,000 words",
      questions: {
        mc_quantity: 5,
        ff_quantity: 3,
        tf_quantity: 5,
        fb_quantity: 5,
        mc_options: 4,
        skills: {
          knowledge: true,
          analysis: true,
          comprehension: true,
          application: true,
        },
      },
      difficulty_level: "Medium",
      genre: "Informational Text",
      text: `The Harlem Renaissance and its role in promoting African American cultural identity.`,
      text_instructions:
        "Include historical figures such as Langston Hughes, Zora Neale Hurston, and W.E.B Du Bois, and discuss how it reshaped art, music, and literature. Assume students have no or very little prior knowledge on the topic.",
      assessment_instructions: "",
    },
  },
  {
    language: "Spanish",
    title: "Reading for a Spanish vocab list",
    template_type: "reading",
    includeUserGroups: ["all"],
    // Exclude takes precedence over include
    excludeUserGroups: ["cy-rav", "cy-sj", "cy-testing", "bt-testing", "bt-ctx"],

    formData: {
      subject: "World Languages",
      grade: "Grade 8",
      show_text: "Open book",
      length: "250 to 500 words",
      questions: {
        mc_quantity: 5,
        ff_quantity: 3,
        tf_quantity: 5,
        fb_quantity: 5,
        mc_options: 4,
        skills: {
          theme: true,
          analysis: true,
          vocabulary: true,
          structure: true,
          tone: true,
        },
      },
      difficulty_level: "Medium",
      genre: "Newspaper Article",
      text: `Write a text using as many of the following vocab words as possible.
      el plato
      la fruta
      la verdura
      el postre
      cortar
      mezclar 
      asar
      la especia
      el sabor
      picar
      cocinar
      la receta
      el ingrediente
      hornear
      freír
      la cena
      el almuerzo
      el desayuno
      el restaurante
      el menú
      pedir
      degustar
      la servilleta
      el camarero/la camarera
      la cuenta 
      ver
      poder
      allí 
      aquí
      tal vez
      ¿Dónde?
      ¿Cuándo?
      cuándo
      `,
      text_instructions: "Bold the vocab words in the passage.",
      assessment_instructions: "",
    },
  },
  {
    language: "English",
    title: "Basic reading fluency and comprehension",
    template_type: "reading",
    includeUserGroups: ["cy-rav", "cy-sj", "cy-testing"],
    // Exclude takes precedence over include
    excludeUserGroups: [],

    formData: {
      subject: "English",
      grade: "Grade 2",
      show_text: "Open book",
      length: "250 to 500 words",
      questions: {
        mc_quantity: 5,
        ff_quantity: 3,
        tf_quantity: 5,
        fb_quantity: 5,
        mc_options: 4,
        skills: {
          theme: true,
          analysis: true,
          vocabulary: true,
          structure: true,
          tone: true,
        },
      },
      difficulty_level: "Easy",
      genre: "Realistic Fiction",
      text: `Write a simple, funny story that makes me laugh. use as many of the following words as possible: sun, moon, star, tree, dog, cat, bird, fish, bug, frog, boy, man. Name the characters Matt and Jack.`,
      text_instructions: "Include a knock-knock joke. Bold the vocab words.",
      assessment_instructions: "",
    },
  },
  {
    language: "English",
    title: "Reading comprehension with texts using specific vocab",
    template_type: "reading",
    includeUserGroups: ["all"],
    // Exclude takes precedence over include
    excludeUserGroups: ["bt-testing", "bt-ctx"],

    formData: {
      subject: "English",
      grade: "Grade 4",
      show_text: "Open book",
      length: "500 to 750 words",
      questions: {
        mc_quantity: 5,
        ff_quantity: 3,
        tf_quantity: 5,
        fb_quantity: 5,
        mc_options: 4,
        skills: {
          theme: true,
          analysis: true,
          vocabulary: true,
          structure: true,
          tone: true,
        },
      },
      difficulty_level: "Easy",
      genre: "Realistic Fiction",
      text: "Write a text using as many of the following vocab words as possible. \n Adventure: A fun, exciting trip where you discover new things. \n Brave: Being strong and fearless, especially in tough situations. \n Clever: Smart at figuring things out quickly and creatively. \n Discover: Finding something surprising while looking for it or not. \n Enormous: Really, really big; much bigger than usual. \n Fragile: Breaks or gets hurt easily, handle with care. \n Giggle: A silly, light laugh when you are amused or nervous. \n Harvest: Collecting crops when they're ready from the farm. \n Invisible: Something you can't see at all. \n Journey: Traveling from one place to another place. \n Kindness: Being nice, caring, and helpful to others. \n Mysterious: Something strange that's hard to figure out or explain. \n Neighbor: Someone who lives very close to you. \n Observe: Watching carefully and noticing details. \n Puzzle: A game or problem that makes you think hard to solve it.",
      text_instructions: "Bold the vocab words in the passage",
      assessment_instructions: "",
    },
  },
  {
    language: "English",
    title: "How Halloween came to be",
    template_type: "reading",
    includeUserGroups: ["all"],
    // Exclude takes precedence over include
    excludeUserGroups: ["bt-testing", "bt-ctx"],

    formData: {
      subject: "Social studies",
      grade: "Grade 3",
      show_text: "Open book",
      length: "250 to 500 words",
      questions: {
        mc_quantity: 5,
        ff_quantity: 0,
        tf_quantity: 5,
        fb_quantity: 0,
        mc_options: 4,
        skills: {
          theme: true,
          analysis: true,
          vocabulary: true,
          structure: true,
          tone: true,
        },
      },
      difficulty_level: "Easy",
      genre: "Historical Narrative",
      text: "Write a text that helps my students understand how Halloween came about. Make the text relatable for my students.",
      text_instructions: "",
      assessment_instructions: "",
    },
  },
  {
    language: "English",
    title: "Learn about Ancient Rome",
    template_type: "reading",
    includeUserGroups: ["all"],
    // Exclude takes precedence over include
    excludeUserGroups: ["bt-testing", "bt-ctx"],

    formData: {
      subject: "History",
      grade: "Grade 4",
      show_text: "Open book",
      length: "250 to 500 words",
      questions: {
        mc_quantity: 5,
        ff_quantity: 2,
        tf_quantity: 5,
        fb_quantity: 3,
        mc_options: 4,
        skills: {
          theme: true,
          analysis: true,
          vocabulary: true,
          structure: true,
          tone: true,
        },
      },
      difficulty_level: "Easy",
      genre: "Historical Narrative",
      text: "Write a fun, engaging article about Ancient Rome, focusing on how the Senate worked. Make it relatable and fun to read for a 9-year-old, so they stay interested and read all the way through.",
      text_instructions: "",
      assessment_instructions: "",
    },
  },
  {
    language: "English",
    title: "Background info on rock types and formation",
    template_type: "reading",
    includeUserGroups: ["all"],
    // Exclude takes precedence over include
    excludeUserGroups: ["bt-testing", "bt-ctx"],

    formData: {
      subject: "Science",
      grade: "Grade 5",
      show_text: "Open book",
      length: "250 to 500 words",
      questions: {
        mc_quantity: 5,
        ff_quantity: 3,
        tf_quantity: 5,
        fb_quantity: 0,
        mc_options: 4,
        skills: {
          theme: true,
          analysis: true,
          vocabulary: true,
          structure: false,
          tone: false,
        },
      },
      difficulty_level: "Medium",
      genre: "Informational Text",
      text: `Rock types and formation (igneous, sedimentary, and metamorphic)`,
      text_instructions: "",
      assessment_instructions: "",
    },
  },
  {
    language: "English",
    title: "Two sides of a classroom debate around MLK (one side)",
    template_type: "reading",
    includeUserGroups: ["all"],
    // Exclude takes precedence over include
    excludeUserGroups: ["bt-testing", "bt-ctx"],

    formData: {
      subject: "History",
      grade: "Grade 10",
      show_text: "Closed book",
      length: "750 to 1,000 words",
      questions: {
        mc_quantity: 5,
        ff_quantity: 5,
        tf_quantity: 1,
        fb_quantity: 0,
        mc_options: 4,
        skills: {
          knowledge: false,
          analysis: true,
          comprehension: true,
          application: true,
        },
      },
      difficulty_level: "Medium",
      genre: "Excerpt from a Scholarly Paper",
      text: `Write a paper arguing that Martin Luther King's contributions to the Civil Rights Movement were limited to the South, because he did not sufficiently address the problems of Black people living in urban North and West.`,
      text_instructions:
        'Fully define and explain all terms, laws, events, people and places. Write this paper for students who have very little existing knowledge of the material. Make sure to focus on and explain terms like "structural racism," "de facto segregation," and "redlining".',
      assessment_instructions: "",
    },
  },
  {
    language: "English",
    title: "Two sides of a classroom debate around MLK (the other side)",
    template_type: "reading",
    includeUserGroups: ["all"],
    // Exclude takes precedence over include
    excludeUserGroups: ["bt-testing", "bt-ctx"],

    formData: {
      subject: "History",
      grade: "Grade 10",
      show_text: "Closed book",
      length: "750 to 1,000 words",
      questions: {
        mc_quantity: 5,
        ff_quantity: 3,
        tf_quantity: 2,
        fb_quantity: 2,
        mc_options: 4,
        skills: {
          knowledge: false,
          analysis: true,
          comprehension: true,
          application: true,
        },
      },
      difficulty_level: "Medium",
      genre: "Excerpt from a Scholarly Paper",
      text: `Write a paper arguing the OPPOSITE side of the following argument: That Martin Luther King's contributions to the Civil Rights Movement were limited to the South, because he did not sufficiently address the problems of Black people living in urban North and West.`,
      text_instructions:
        "Fully define and explain all terms, laws, events, people and places. Write this paper for students who have very little existing knowledge of the material.",
      assessment_instructions: "",
    },
  },
  {
    language: "Spanish",
    title: "Cultural activity– Hanukkah in Spanish-speaking countries",
    template_type: "reading",
    includeUserGroups: ["all"],
    // Exclude takes precedence over include
    excludeUserGroups: ["cy-rav", "cy-sj", "cy-testing", "bt-testing", "bt-ctx"],

    formData: {
      subject: "World Languages",
      grade: "Grade 7",
      show_text: "Open book",
      length: "250 to 500 words",
      questions: {
        mc_quantity: 5,
        ff_quantity: 3,
        tf_quantity: 5,
        fb_quantity: 5,
        mc_options: 4,
        skills: {
          theme: true,
          analysis: true,
          vocabulary: true,
          structure: true,
          tone: true,
        },
      },
      difficulty_level: "Medium",
      genre: "Informational Text",
      text: `Hanukkah in Spanish-speaking countries`,
      text_instructions: "",
      assessment_instructions: "",
    },
  },

];
